module.exports = __webpack_public_path__ + "static/media/Review-02.f592372a.png";